import { Th } from '@chakra-ui/react'
import React, { ReactElement } from 'react'
import { HeaderGroup, IdType } from 'react-table'
import { FilledArrow, Updown } from '../../icons'
import { useColor } from '../../theme'
import { Direction } from '../../icons/definitions'
import { TTableRowData } from './types'
import { Button } from '@rw1/shared-lib'

// By default the `md` size `Button` has -4 padding-inline-start,
// in order to align button to the start of the cell, -4 is set as marginLeft.
const MARGIN_LEFT = -4

interface IHeaderProps<T extends TTableRowData> {
  column: HeaderGroup<T>
  onClick?: (columnId: IdType<T>) => void
  hideHeader?: boolean
  hasCustomAction?: boolean
}

export function TableHeader<T extends TTableRowData>({
  column,
  onClick,
  hideHeader,
  hasCustomAction,
}: IHeaderProps<T>): ReactElement {
  const { onClick: reactTableSortOnClick, ...sortToggleByProps } =
    column.getSortByToggleProps({ title: undefined })  // return type can be extended via interface merging in `react-table-config.d.ts`

  const actionTextColor = useColor({ nuance: 6, palette: 'text' })

  if (!column.Header) {
    return (
      <Th
        {...column.getHeaderProps(sortToggleByProps)}
        as="div"
        display="flex"
        fontSize="md"
        role="columnheader"
        textTransform="inherit"
      />
    )
  }

  return (
    <Th
      {...column.getHeaderProps(sortToggleByProps)}
      as="div"
      display="flex"
      fontSize="md"
      onClick={(e) => {
        // keep this order!
        reactTableSortOnClick?.(e)
        onClick?.(column.id)
      }}
      role="columnheader"
      textTransform="inherit">
      <Button
        cursor={column.canSort || hasCustomAction ? 'pointer' : 'default'}
        fontSize="sm"
        marginLeft={MARGIN_LEFT}
        pointerEvents={column.canSort || hasCustomAction ? 'auto' : 'none'}
        variant="headerTable"
        visibility={hideHeader ? 'hidden' : 'visible'}>
        {column.render('Header')}
        {column.canSort &&
          (column.isSortedDesc !== undefined ? (
            <FilledArrow
              color={actionTextColor}
              direction={column.isSortedDesc ? Direction.Down : Direction.Up}
              marginLeft={1}
            />
          ) : (
            <Updown marginLeft={1} />
          ))}
      </Button>
    </Th>
  )
}
